import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import Header from '../../components/Header';
import DotsMenu from '../../components/3DotsMenu';
import TasksSidebar from '../../components/TasksSidebar';
import StatusFilter from '../../components/StatusFilter';
import StartMaking from '../../components/StartMaking';
import { isAuthenticated } from '../../auth/index';
import AddIcon from '@material-ui/icons/Add';
import LinearProgress from '@material-ui/core/LinearProgress';
import LifecycleBar from '../../components/LifecycleBar';
import Moment from 'react-moment';
import { Link } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';
import DesignIcon from '../../icons/DesignIcon';
import PreProductionIcon from '../../icons/PreProductionIcon';
import ProductionIcon from '../../icons/ProductionIcon';
import ShippingIcon from '../../icons/ShippingIcon';
import SocketContext from '../../socket-context';
import { getFromStorage, updateStorage } from '../../services/storage';
import { toast } from 'react-toastify';
import {
    Select,
    MenuItem
} from "@material-ui/core";
import Footer from '../../components/Footer';

class Dashboard extends Component {
    constructor() {
        super();
        this.state = {
            products : [],
            productsFulfilled : [],
            productsReview : [],
            limitActive: 5,
            limitReview:5,
            limitFulfilled:5,
            originalArrayProducts: [],
            isLoadingDashboard: true,
            redirect: false,
        };
        this.list = React.createRef();
    }
    
    componentDidMount() {
        this.getAllProducts();
    
        const {
            socket
        } = this.props;
        socket.on('connect', function() {
            console.log('Conectado al Servidor');
            socket.emit('login', isAuthenticated(), function(resp) {
                console.log('Usarios Conectados',  resp);
            });
        });
        
        socket.on('disconnect', function() {
            console.log('Servidor Desconectado');
        });

        socket.on('newProduct', (response) => {
            let pr = [response.data.product];
            this.setState({
                productsReview: [
                    ...pr,
                    ...this.state.productsReview
                ]
            });
        });
    }

    togglePercentage = (status, active) => {
        switch (status) {
            case "DESIGN" : 
                            if (active){return 20} else {return 0}
            case "PRE-PRODUCTION" : 
                            if (active) { return 40} else { return 0} 
            case "PRODUCTION" : 
                            if (active) { return 60} else { return 0} 
            case "SHIPPING" : 
                            if (active) { return 80} else { return 0} 
            case "FULFILLED" : 
                            if (active) { return 100} else { return 0} 
            default : if (active) { return 20} else { return 0} 
        }
    };

    toggleClass(status)  {
        switch (status) {
            case "DESIGN" : return 'statusDesign';
            case "PRE-PRODUCTION" : return 'statusPre';
            case "PRODUCTION" : return 'statusProd';
            case "SHIPPING" : return 'statusShipping';
            case "FULFILLED" : return 'statusFulfilled';
            default : return 'statusDesign';
        }
    };

    toggleIcon(status) {
        switch (status) {
            case "DESIGN": return <DesignIcon color="#9998AF"/>;
            case "PRE-PRODUCTION": return <PreProductionIcon color="#9998AF"/>;
            case "PRODUCTION": return <ProductionIcon color="#9998AF"/>;
            case "SHIPPING": return <ShippingIcon color="#9998AF"/>;
            default: return <DesignIcon color="#9998AF"/>;
        }
    }
    
    getProducts(AllProduct, AllProductFilled, AllProductReview) {
        this.setState({
            products : AllProduct,
            productsFulfilled : AllProductFilled,
            productsReview : AllProductReview
        });
    };
    
    getAllProducts = () => {
        fetch(`${process.env.REACT_APP_DOMAIN_BACK}/product/${isAuthenticated().companyActually.slug}/list`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                Authorization: `Bearer ${isAuthenticated().token}`,
            }
        })
        .then(res => res.json())
        .then(json => {
            if (json.error) {
                toast.error(json.error)
            }
            this.setState({
                originalArrayProducts : json,
                isLoadingDashboard: false
            });
            const activeProducts = json.filter(active => active.status !== "FULFILLED" && active.isActive === true);
            const finishedProducts = json.filter(finish => finish.status === "FULFILLED");
            const reviewProducts = json.filter(review => review.status !== 'FULFILLED' && review.isActive === false);
            this.getProducts(activeProducts, finishedProducts, reviewProducts);
        })
        .catch(err => console.log(err));
    };
    
    loadMoreActiveProducts = () => {
        this.setState({
            limitActive: this.state.limitActive + 5,
        });
    };

    loadMoreReviewProducts = () => {
        this.setState({
            limitReview: this.state.limitReview + 5,
        });
    };

    loadMoreFulfilledProducts = () => {
        this.setState({
            limitFulfilled: this.state.limitFulfilled + 5,
        });
    };

    changeCompany = (e) => {
        const st = getFromStorage('gembah_user');
        const newCompany = st.companies.filter(company => company._id === e.target.value )[0];
        const newSt = {
            ...st,
            companyActually: newCompany
        }
        updateStorage('gembah_user', newSt);
        this.setState({
            redirect: true
        });
    }

    refreshProducts = () => {
        this.getAllProducts()
    }
    
    render() {
        const {
            products,
            productsFulfilled,
            productsReview,
            limitActive,
            limitReview,
            limitFulfilled,
            originalArrayProducts,
            isLoadingDashboard,
            redirect
        } = this.state;
        
        if (redirect) {
            return <Dashboard {...this.props} />
        }
        return(
            <Grid container>
                <Header />
                <Grid item xs={12} sm={5} md={4} className="whiteBg tasksDiv">
                    <TasksSidebar />
                </Grid>
                <Grid item xs={12} sm={7} md={8} id="productsDiv" className="m-lr-auto p-lr-5 p-b-5">
                    {
                        isAuthenticated().companies.length <= 1 && (isAuthenticated().role === 'user' || isAuthenticated().role === 'owner') ? <h4 className="account workSans ">{isAuthenticated().companyActually.name}</h4> : <Select
                            name="chooseCompany"
                            variant="outlined"
                            value={isAuthenticated().companyActually._id}
                            className="loginInput selectForm productsInput m-t-2 workSans"
                            id='selectCompany'
                            onChange={e => this.changeCompany(e)}
                        >
                            {
                                isAuthenticated().companies.map((company, index) => (
                                    <MenuItem
                                    key={company._id}
                                    className="workSans"
                                    value={company._id}
                                    >
                                        {company.name}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    }
                    <div className="m-tb-2 relative">
                        <h2 className="inlineBlock" style={{marginTop:'6px'}}>PRODUCTS DASHBOARD</h2>
                        <StartMaking refreshProducts={ this.refreshProducts }/>
                         <StatusFilter
                            changeProductList={this.getProducts.bind(this)}
                        />
                    </div>
                    <LifecycleBar productArray={originalArrayProducts}/>
                    <div className="m-t-2">
                    <svg width="20" height="15" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 6.5858L1.70711 4.29291L0.292892 5.70712L4 9.41423L11.7071 1.70712L10.2929 0.292908L4 6.5858Z" fill="#9998AF"/>
                        </svg>
                    <p className="inlineBlock account bold p-lr-2">In review</p>
                    <div id="productsReviewDashboard">
                  
                        <ul>
                            {
                                !isLoadingDashboard ?
                                    Object.keys(productsReview).length ? productsReview.slice(0,limitReview).map((productReview, index) => {
                                        return(
                                            <li className="flex m-tb-2"  key={productReview._id}>
                                                <div className="productImage">
                                                    { this.toggleIcon(productReview.status) }
                                                </div>
                                                <div className="productInfo p-lr-2">
                                                    <Link to={`/${productReview.companyOwner.slug}/${productReview.slug}`}><p>{productReview.name}</p> </Link>
                                                    <p className="account"><Moment format="D MMM YYYY" withTitle>{productReview.created}</Moment></p>
                                                </div>
                                                <div className="productProgress relative">
                                                    <LinearProgress  variant="determinate" classes={{barColorPrimary : this.toggleClass(productReview.status)}} value={this.togglePercentage(productReview.status, productReview.isActive)}/>
                                                    <span className="account"> {this.togglePercentage(productReview.status, productReview.isActive)}%</span>
                                                </div>
                                                <div className="productDots">
                                                    <DotsMenu
                                                        refresh={e => this.getAllProducts() }
                                                        product={productReview}
                                                        
                                                    />
                                                </div>
                                            </li>
                                        )
                                    }) : <li><p className="account">No products being reviewed found</p></li>
                                : <div style={{width: '100px',margin : 'auto'}}><CircularProgress/></div>
                            }
                            {
                                Object.keys(productsReview).length > 5 ? <div className="forgot " id="moreTasks" onClick={this.loadMoreReviewProducts}>
                                    <p><AddIcon />More products</p>
                                </div> : ''
                            }
                        </ul>
                    </div>
                    </div>
                    <div className="m-t-2" >
                    <svg width="20" height="15" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 6.5858L1.70711 4.29291L0.292892 5.70712L4 9.41423L11.7071 1.70712L10.2929 0.292908L4 6.5858Z" fill="#9998AF"/>
                    </svg>
                    <p className="inlineBlock account bold p-lr-2">Being Made</p>
                    <div id="productsDashboard" >
                  
                        <ul>
                            {
                                !isLoadingDashboard ?
                                    Object.keys(products).length ? products.slice(0,limitActive).map((product, index) => {
                                        return(
                                            <li className="flex m-tb-2"  key={product._id}>
                                                <div className="productImage">
                                                    { this.toggleIcon(product.status) }
                                                </div>
                                                <div className="productInfo p-lr-2">
                                                <Link to={`/${product.companyOwner.slug}/${product.slug}`}><p>{product.name}</p> </Link>
                                                    <p className="account"><Moment format="D MMM YYYY" withTitle>{product.created}</Moment></p>
                                                </div>
                                                <div className="productProgress relative">
                                                    <LinearProgress  variant="determinate" classes={{barColorPrimary : this.toggleClass(product.status)}} value={this.togglePercentage(product.status, product.isActive)}/>
                                                    <span className="account">{this.togglePercentage(product.status, product.isActive)}%</span>
                                                </div>
                                                <div className="productDots">
                                                    <DotsMenu
                                                        refresh={e => this.getAllProducts() }
                                                        product={product}
                                                    />
                                                </div>
                                            </li>
                                        )
                                    }) : <li><p className="account">No active products found</p></li>
                                : <div style={{width: '100px',margin : 'auto'}}><CircularProgress/></div>
                            }
                            {
                                Object.keys(products).length > 5 ? <div className="forgot " id="moreTasks" onClick={this.loadMoreActiveProducts}>
                                    <p><AddIcon />More products</p>
                                </div> : ''
                            }
                        </ul>
                    </div>
                    </div>
                    <div id="fulfilledDashboard" className="p-tb-5">
                        <svg width="20" height="15" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 6.5858L1.70711 4.29291L0.292892 5.70712L4 9.41423L11.7071 1.70712L10.2929 0.292908L4 6.5858Z" fill="#9998AF"/>
                        </svg>
                        <p className="account inlineBlock p-lr-2" id="fulfilledTitle">Fulfilled</p>
                        <ul>
                            {
                                Object.keys(productsFulfilled).length ? productsFulfilled.slice(0,limitFulfilled).map((fulfilled,index) => {
                                    return(
                                        <li className="flex m-tb-2"   key={fulfilled._id}>
                                            <div className="productImage">
                                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17 31L17.6306 30.2238L17 29.7116L16.3694 30.2239L17 31ZM16.8164 31.1492L17.4469 31.9253L17.4469 31.9253L16.8164 31.1492ZM8.83186 28.5548L7.86553 28.8121L7.86553 28.8121L8.83186 28.5548ZM8.771 28.3262L9.73734 28.069L9.52832 27.2839L8.71706 27.3277L8.771 28.3262ZM8.53476 28.339L8.58869 29.3375L8.58869 29.3375L8.53476 28.339ZM3.60006 21.547L4.53307 21.9068L4.53307 21.9068L3.60006 21.547ZM3.6852 21.3262L4.61821 21.6861L4.91057 20.9281L4.2285 20.4867L3.6852 21.3262ZM3.48658 21.1977L2.94328 22.0372L2.94328 22.0372L3.48658 21.1977ZM3.48658 12.8023L2.94328 11.9627L3.48658 12.8023ZM3.6852 12.6737L4.2285 13.5133L4.91057 13.0719L4.61821 12.3139L3.6852 12.6737ZM3.60006 12.453L2.66706 12.8129L2.66706 12.8129L3.60006 12.453ZM8.53476 5.66099L8.48083 6.65953L8.48083 6.65953L8.53476 5.66099ZM8.771 5.67375L8.71707 6.67229L9.52832 6.71611L9.73734 5.93102L8.771 5.67375ZM8.83186 5.44513L7.86553 5.18786L7.86553 5.18786L8.83186 5.44513ZM16.8164 2.85081L16.1858 3.62695L16.1858 3.62695L16.8164 2.85081ZM17 2.99999L16.3694 3.77613L17 4.28842L17.6306 3.77612L17 2.99999ZM17.1836 2.85081L16.553 2.07467L16.553 2.07467L17.1836 2.85081ZM25.1681 5.44513L24.2018 5.7024L24.2018 5.70241L25.1681 5.44513ZM25.229 5.67375L24.2626 5.93103L24.4717 6.71611L25.2829 6.67229L25.229 5.67375ZM25.4652 5.66099L25.4113 4.66244L25.4113 4.66244L25.4652 5.66099ZM30.3999 12.453L29.4669 12.0932L29.4669 12.0932L30.3999 12.453ZM30.3148 12.6737L29.3818 12.3139L29.0894 13.0719L29.7715 13.5133L30.3148 12.6737ZM30.5134 12.8023L31.0567 11.9627L31.0567 11.9627L30.5134 12.8023ZM30.5134 21.1977L31.0567 22.0372L31.0567 22.0372L30.5134 21.1977ZM30.3148 21.3262L29.7715 20.4867L29.0894 20.9281L29.3818 21.6861L30.3148 21.3262ZM30.3999 21.547L29.4669 21.9068L29.4669 21.9068L30.3999 21.547ZM25.4652 28.339L25.4113 29.3375L25.4113 29.3375L25.4652 28.339ZM25.229 28.3262L25.2829 27.3277L24.4717 27.2839L24.2626 28.069L25.229 28.3262ZM25.1681 28.5548L24.2018 28.2976L24.2018 28.2976L25.1681 28.5548ZM17.1836 31.1492L17.8142 30.373L17.8142 30.373L17.1836 31.1492ZM15.7071 22.7071L15 22L15.7071 22.7071ZM24.7071 13.7071L25.4142 14.4142L26.1213 13.7071L25.4142 13L24.7071 13.7071ZM15 23.4142L14.2929 24.1213L15 24.8284L15.7071 24.1213L15 23.4142ZM14.2929 22.7071L15 22L14.2929 22.7071ZM9.29288 17.7071L8.58578 17L7.87867 17.7071L8.58578 18.4142L9.29288 17.7071ZM10.7071 16.2929L11.4142 15.5858L10.7071 14.8787L9.99999 15.5858L10.7071 16.2929ZM15 20.5858L14.2929 21.2929L15 22L15.7071 21.2929L15 20.5858ZM23.2929 12.2929L24 11.5858L23.2929 10.8787L22.5858 11.5858L23.2929 12.2929ZM16.3694 30.2239L16.1858 30.373L17.4469 31.9253L17.6306 31.7761L16.3694 30.2239ZM16.1858 30.373C13.934 32.2025 10.5446 31.1012 9.7982 28.2976L7.86553 28.8121C8.98516 33.0176 14.0692 34.6695 17.4469 31.9253L16.1858 30.373ZM9.7982 28.2976L9.73734 28.069L7.80466 28.5835L7.86553 28.8121L9.7982 28.2976ZM8.71706 27.3277L8.48082 27.3404L8.58869 29.3375L8.82493 29.3248L8.71706 27.3277ZM8.48083 27.3404C5.58376 27.4969 3.48901 24.6137 4.53307 21.9068L2.66706 21.1871C1.10097 25.2475 4.24309 29.5722 8.58869 29.3375L8.48083 27.3404ZM4.53307 21.9068L4.61821 21.6861L2.75219 20.9664L2.66706 21.1871L4.53307 21.9068ZM4.2285 20.4867L4.02988 20.3581L2.94328 22.0372L3.1419 22.1658L4.2285 20.4867ZM4.02988 20.3582C1.59413 18.7819 1.59413 15.2181 4.02988 13.6418L2.94328 11.9627C-0.710342 14.3271 -0.710342 19.6728 2.94328 22.0372L4.02988 20.3582ZM4.02988 13.6418L4.2285 13.5133L3.1419 11.8342L2.94328 11.9627L4.02988 13.6418ZM4.61821 12.3139L4.53307 12.0932L2.66706 12.8129L2.75219 13.0336L4.61821 12.3139ZM4.53307 12.0932C3.48901 9.38623 5.58376 6.50306 8.48083 6.65953L8.58869 4.66245C4.24309 4.42773 1.10097 8.7525 2.66706 12.8129L4.53307 12.0932ZM8.48083 6.65953L8.71707 6.67229L8.82493 4.6752L8.58869 4.66245L8.48083 6.65953ZM9.73734 5.93102L9.7982 5.7024L7.86553 5.18786L7.80466 5.41648L9.73734 5.93102ZM9.7982 5.7024C10.5446 2.89878 13.934 1.7975 16.1858 3.62695L17.4469 2.07467C14.0692 -0.669498 8.98516 0.982415 7.86553 5.18786L9.7982 5.7024ZM16.1858 3.62695L16.3694 3.77613L17.6306 2.22385L17.4469 2.07467L16.1858 3.62695ZM17.6306 3.77612L17.8142 3.62694L16.553 2.07467L16.3694 2.22385L17.6306 3.77612ZM17.8142 3.62694C20.066 1.7975 23.4554 2.89878 24.2018 5.7024L26.1345 5.18786C25.0148 0.982414 19.9308 -0.669499 16.553 2.07467L17.8142 3.62694ZM24.2018 5.70241L24.2626 5.93103L26.1953 5.41647L26.1345 5.18785L24.2018 5.70241ZM25.2829 6.67229L25.5192 6.65953L25.4113 4.66244L25.1751 4.6752L25.2829 6.67229ZM25.5192 6.65953C28.4162 6.50306 30.511 9.38624 29.4669 12.0932L31.3329 12.8129C32.899 8.7525 29.7569 4.42773 25.4113 4.66244L25.5192 6.65953ZM29.4669 12.0932L29.3818 12.3139L31.2478 13.0336L31.3329 12.8129L29.4669 12.0932ZM29.7715 13.5133L29.9701 13.6418L31.0567 11.9627L30.8581 11.8342L29.7715 13.5133ZM29.9701 13.6418C32.4059 15.2181 32.4059 18.7819 29.9701 20.3581L31.0567 22.0372C34.7103 19.6728 34.7103 14.3271 31.0567 11.9627L29.9701 13.6418ZM29.9701 20.3581L29.7715 20.4867L30.8581 22.1658L31.0567 22.0372L29.9701 20.3581ZM29.3818 21.6861L29.4669 21.9068L31.3329 21.1871L31.2478 20.9664L29.3818 21.6861ZM29.4669 21.9068C30.511 24.6137 28.4162 27.4969 25.5192 27.3404L25.4113 29.3375C29.7569 29.5722 32.899 25.2475 31.3329 21.1871L29.4669 21.9068ZM25.5192 27.3404L25.2829 27.3277L25.1751 29.3248L25.4113 29.3375L25.5192 27.3404ZM24.2626 28.069L24.2018 28.2976L26.1345 28.8121L26.1953 28.5835L24.2626 28.069ZM24.2018 28.2976C23.4554 31.1012 20.066 32.2025 17.8142 30.373L16.5531 31.9253C19.9308 34.6695 25.0148 33.0176 26.1345 28.8121L24.2018 28.2976ZM17.8142 30.373L17.6306 30.2238L16.3694 31.7761L16.5531 31.9253L17.8142 30.373ZM16.4142 23.4142L25.4142 14.4142L24 13L15 22L16.4142 23.4142ZM15.7071 24.1213L16.4142 23.4142L15 22L14.2929 22.7071L15.7071 24.1213ZM13.5858 23.4142L14.2929 24.1213L15.7071 22.7071L15 22L13.5858 23.4142ZM8.58578 18.4142L13.5858 23.4142L15 22L9.99999 17L8.58578 18.4142ZM9.99999 15.5858L8.58578 17L9.99999 18.4142L11.4142 17L9.99999 15.5858ZM15.7071 19.8787L11.4142 15.5858L9.99999 17L14.2929 21.2929L15.7071 19.8787ZM22.5858 11.5858L14.2929 19.8787L15.7071 21.2929L24 13L22.5858 11.5858ZM25.4142 13L24 11.5858L22.5858 13L24 14.4142L25.4142 13Z" fill="#9998AF"/>
                                                </svg>
                                            </div>
                                            <div className="productInfo p-lr-2">
                                                <Link to={`/${fulfilled.companyOwner.slug}/${fulfilled.slug}`}><p>{fulfilled.name}</p> </Link>
                                                <p className="account"><Moment format="D MMM YYYY" withTitle>{fulfilled.created}</Moment></p>
                                            </div>
                                            <div className="productProgress relative">
                                                <LinearProgress  variant="determinate" classes={{barColorPrimary : this.toggleClass(fulfilled.status)}} value={this.togglePercentage(fulfilled.status, fulfilled.isActive)}/>
                                                <span className="account">{this.togglePercentage(fulfilled.status, fulfilled.isActive)}%</span>
                                            </div>
                                            <div className="productDots">
                                                <DotsMenu
                                                    refresh={e => this.getAllProducts() }
                                                    product={fulfilled}
                                                />
                                            </div>
                                        </li>
                                    )
                                }) : <li><p className="account">No fulfilled products found</p></li>
                            }
                            {
                                Object.keys(productsFulfilled).length > 5 ?  
                                <div className="forgot " id="moreTasks" onClick={this.loadMoreFulfilledProducts}>
                                <p><AddIcon />More products</p>
                                </div> 
                                : 
                                ''
                            }
                        </ul>
                    </div>
                </Grid>
                <Footer />
            </Grid>
        )
    }
}

const DashboardWithSocket = props => (
    <SocketContext.Consumer>
        {socket => <Dashboard {...props} socket={socket} />}
    </SocketContext.Consumer>
)

export default DashboardWithSocket;